import React from 'react';
import cx from 'classnames';
import { DatasheetElementResizeDirection } from '../../hooks/datasheet-element.controller';
import { Resizer } from './components/resizer';

import './movable-item.styles.scss';

export type MovableItemProps = React.PropsWithChildren<{
  width: number;
  height: number;
  selected?: boolean;
  showBorder?: boolean;
  onMouseDown?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  resizing: {
    enabled: boolean;
    onChange: (e: React.MouseEvent<HTMLDivElement>, direction: DatasheetElementResizeDirection) => void;
  };
  reference: React.RefObject<HTMLDivElement>;
  className?: string;
  moving: {
    enabled: boolean;
  };
}>;

export const MovableItem: React.FC<MovableItemProps> = (props) => {
  const { onMouseDown, children, selected, onClick, height, width, resizing, reference, showBorder, className, moving } = props;

  const resizers: Record<DatasheetElementResizeDirection, { className: string }> = {
    [DatasheetElementResizeDirection.nw]: {
      className: 'top-left',
    },
    [DatasheetElementResizeDirection.ne]: {
      className: 'top-right',
    },
    [DatasheetElementResizeDirection.sw]: {
      className: 'bottom-left',
    },
    [DatasheetElementResizeDirection.se]: {
      className: 'bottom-right',
    },
    [DatasheetElementResizeDirection.n]: {
      className: 'top',
    },
    [DatasheetElementResizeDirection.e]: {
      className: 'right',
    },
    [DatasheetElementResizeDirection.s]: {
      className: 'bottom',
    },
    [DatasheetElementResizeDirection.w]: {
      className: 'left',
    }
  };

  return (
    <div
      className={cx(
        "DatasheetsEditorDatasheetMovableItem", 
        { 
          "DatasheetsEditorDatasheetMovableItem--movable": moving.enabled,
          "DatasheetsEditorDatasheetMovableItem--selected": selected,
          "DatasheetsEditorDatasheetMovableItem--bordered": showBorder,
        },
        className
      )}
      onMouseDown={onMouseDown}
      style={{
        minHeight: height,
        minWidth: width,
      }}
      ref={reference}
      onClick={onClick}
    >
      {children}
      {resizing.enabled && Object.keys(resizers).map((x) => (
        <Resizer
          key={x}
          className={cx(
            'DatasheetsEditorDatasheetMovableItem__resizer', 
            `DatasheetsEditorDatasheetMovableItem__resizer--${resizers[x as DatasheetElementResizeDirection].className}`
          )}
          onMouseDown={resizing.onChange}
          direction={x as DatasheetElementResizeDirection}
        /> 
      ))}
    </div>
  );
};
